/** 
* Page : RoomsView 
* 
* It's rooms details 
* 
*/

<template>
  <div>
  <!-- General description about rooms -->
    <header class="items_container">
        <MainTitle
          :title="$t('rooms.mainTitle')"
          :subtitle="$t('rooms.subTitle')"
          background="title_blue"
        ></MainTitle>
    </header>
    <!-- Description about first room -->
    <section class="items_description">
      <div>
        <PresentationCard
          :anchor="$t('rooms.anchorRoom1')"
          :title="$t('rooms.textRoom1')"
          :items="room1Items"
          :MoreInformationUrl="buttons.urlRoom1"
          :MoreInformationText="$t('rooms.moreInformation')"
          :item_alt="$t('rooms.altRoom1')"
          :item_url="pictures.srcRoom1"
          :id="room1"
          @show-more="openModal('room1')" 
          ></PresentationCard>
      </div>
      <div>
       <!-- Description about second room -->
        <PresentationCard
          :anchor="$t('rooms.anchorRoom2')"
          :title="$t('rooms.textRoom2')"
             :items="room2Items"
          :MoreInformationUrl="buttons.urlRoom2"
          :MoreInformationText="$t('rooms.moreInformation')"
          :item_alt="$t('rooms.altRoom2')"
          :item_url="pictures.srcRoom2"
           :id="room2"
           @show-more="openModal('room2')" 
        ></PresentationCard>
      </div>

      <div>
      <!-- Description about third room -->
        <PresentationCard 
          :anchor="$t('rooms.anchorRoom3')"
          :title="$t('rooms.textRoom3')"
             :items="room3Items"
          :MoreInformationUrl="buttons.urlRoom2"
          :MoreInformationText="$t('rooms.moreInformation')"
          :item_alt="$t('rooms.altRoom3')"
          :item_url="pictures.srcRoom3"
           :id="room3"
           @show-more="openModal('room3')" 
        ></PresentationCard>
      </div>

  <!-- If modal is visible, call popupContent to display popup with informations of a room id-->
      <div v-if="isModalVisible" class="modal_overlay" @click="closeModal">
      <div class="modal_content" @click.stop>
        <PopupContent 
        :titlepopup="$t('rooms.titlePopup')"
          :dimensions="currentRoom.dimension"
          :peoplenumber="currentRoom.peopleNumber"
          :sections="currentRoom.sections" 
          />
        <button class="close_button" @click="closeModal">X</button>
      </div>
    </div>
    </section>

    <!-- Informs the user of the house's location -->
     <div class="dispo_btn">
      <PageLink
        :url="buttons.urlReservation"
        :text="$t('rooms.textButton')"
        background="blue"
      />
     </div>
     </div>

</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
import PresentationCard from "@/components/PresentationCard.vue";
import PopupContent from "@/components/PopupContent.vue";
import PageLink from "@/components/PageLink.vue";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from "@/locales/de.json";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
  name: "RoomsView",

    // import
  components: { 
    MainTitle, 
    PresentationCard, 
    PopupContent,
    PageLink },

     setup() {
      const { locale } = useI18n();
      const sectionsMap = {
    fr: fr.rooms.sections,
    en: en.rooms.sections,
    de: de.rooms.sections // <-- ajoute ici ton fichier allemand
  };
 const sectionsRoom1 = computed(() => sectionsMap[locale.value]?.sectionRoom1 || fr.rooms.sections.sectionRoom1);
  const sectionsRoom2 = computed(() => sectionsMap[locale.value]?.sectionRoom2 || fr.rooms.sections.sectionRoom2);
  const sectionsRoom3 = computed(() => sectionsMap[locale.value]?.sectionRoom3 || fr.rooms.sections.sectionRoom3);

    return {sectionsRoom1, sectionsRoom2,sectionsRoom3  }
  },

  data() {
    return {
      room1: null, room2: null, room3: null,
      isModalVisible: false, //by default the modal isn't activ (don't display popup)
      currentRoom: {}, //by default no id room is contain
      
      texts: {  
        dimensionRoom1: "17 m²",
        dimensionRoom2: "17 m²",
        dimensionRoom3: "10 m²",
        peopleRoom1:"👤 2",
        peopleRoom2:"👤 2",
        peopleRoom3:"👤 2",
      },

      pictures: {
        srcRoom1: [
          require("../assets/images/rooms/mer1.jpg"),
            require("../assets/images/rooms/mer2.jpg")
      ],
         srcRoom2: [
          require("../assets/images/rooms/terre1.jpg"),
          require("../assets/images/rooms/terre2.jpg")
      ],
         srcRoom3: [
          require("../assets/images/rooms/rencontre1.jpg"),
          require("../assets/images/rooms/rencontre2.jpg")
      ],

     
      },
      buttons: {
        urlReservation: "/diponible-merrien",
      },
    };
  },

  //if modal is true and contain an id, display informations about room id (look call component PopupContent)
  methods:{
    openModal(roomId){
      this.isModalVisible = true;
      this.$nextTick(() => {
        // Ajoute la classe `visible` pour commencer l'animation
        document.querySelector('.modal_overlay').classList.add('visible');
        document.querySelector('.modal_content').classList.add('visible');
      });
    
      switch (roomId){
        case 'room1':
          return this.currentRoom = {
          dimension:this.texts.dimensionRoom1,
          peopleNumber:this.texts.peopleRoom1,
          sections: this.sectionsRoom1
         
        }; 
        case 'room2':
        return this.currentRoom = {
          dimension:this.texts.dimensionRoom2,
          peopleNumber:this.texts.peopleRoom2,
         sections: this.sectionsRoom2
        };
        case 'room3':
        return this.currentRoom = {
          dimension:this.texts.dimensionRoom3,
          peopleNumber:this.texts.peopleRoom3,
          sections: this.sectionsRoom3
        };
        default:
          return this.isModalVisible = false;
      }
    },
    closeModal() {
      this.isModalVisible = false;
      document.querySelector('.modal_overlay').classList.remove('visible');
      document.querySelector('.modal_content').classList.remove('visible');

         // Cache le modal après l'animation
         setTimeout(() => {
        this.isModalVisible = false;
      }, 300); // Doit correspondre à la durée de l'animation
    }
  },
  //gère le overflow du body pour qu'il soit figé quand le popup est ouvert
  watch: {
  isModalVisible(newVal) {
    if (newVal) {
       const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';  // Bloque scroll page
       document.body.style.marginRight = `${scrollbarWidth}px`; // ← Ajout important
    } else {
      document.body.style.overflow = '';        // Restaure scroll page
       document.body.style.marginRight = ''; // ← Restaure le margin
    }
  }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.items_container {
  max-width: 75%;
  margin: $spacing-extralarge auto;

}

.items_description {
  display: flex;
  justify-content: center; 
  gap:2.5rem ;
  flex-wrap: wrap;  // autorise retour à la ligne
  max-width: 1200px;
  margin: 0 auto;
}

.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  transition: opacity 0.5s ease; /* Animation de l'apparition */
  z-index: 1000;
}

.modal_content {
  background-color: white;
  border-radius: 0.6em;
  max-width: 56rem;
  max-height: 45rem;
  width: 80%;
  opacity: 0; /* Le contenu est invisible au départ */
  transition: opacity 0.3s ease, transform 0.3s ease; /* Animation de l'apparition *
  overflow-y: auto; /* scroll vertical si contenu dépasse */
  -webkit-overflow-scrolling: touch; /* pour un scroll fluide sur iOS */
  position: relative; /* pour le bouton fermer */
  
}

.modal_overlay.visible {
  opacity: 1;
  pointer-events: all;
}

.modal_content.visible {
  opacity: 1; /* Le contenu devient visible */
  transform: translateY(0); /* Il monte à sa position initiale */
}

.close_button {
  position: absolute;
  top: 1rem;
  right: 1.8rem;
  background-color: transparent;
  color: $default-color;
  border: none;
 
  border-radius: 0.3rem;
  cursor: pointer;
}

@media (max-width: 48rem) {
  .items_container,
  .items_description {
    flex-direction: column;
    align-items: center;
  }
.items_container {
  max-width: 90%;
}
}
</style>